let accessToken: string | null = null;
const FORCE_LOGGED_OUT_KEY = "force_logged_out";

export const AuthService = {
  setToken(token: string | null) {
    accessToken = token;
  },

  getToken(): string | null {
    return accessToken;
  },

  removeToken() {
    accessToken = null;
  },

  setForceLoggedOut(value: boolean) {
    if (value) {
      localStorage.setItem(FORCE_LOGGED_OUT_KEY, "1");
      return;
    }
    localStorage.removeItem(FORCE_LOGGED_OUT_KEY);
  },

  isForceLoggedOut(): boolean {
    return localStorage.getItem(FORCE_LOGGED_OUT_KEY) === "1";
  },

  getAuthHeaders(): Record<string, string> {
    const token = this.getToken();
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return headers;
  },

};
